import React, {useState, useEffect, useRef, useImperativeHandle} from "react";
import {Card, CardBody, Container, Row, Col} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar} from "antd";
import Select from "react-select"; // Adicionado import para Select

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ImportModal from "../import/ImportModal";
import UsersSearch from "../dashboard/calender/UsersSearch";
import CustomPagination from "../util/CustomPagination";
import OfficerModal from "./OfficerModal";

const OfficerPage = () => {
    document.title = "Funcionários | Plantão Rápido";
    const refUserSearch = useRef(null);
    const [showImportModal, setShowImportModal] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [usersOfficer, setUsersOfficer] = useState([]);
    const [filters, setFilters] = useState({
        status: null,
        user_id: '',
    });

    const options = [
        {value: "accepted", label: "Ativo"},
        {value: "cancel", label: "Inativo"},
    ];

    const [pagination, setPagination] = useState({current: 1, pageSize: 5, total: 0, lastPage: 0});
    const [showOfficerModal, setShowOfficerModal] = useState(false);
    const [importType, setImportType] = useState(null);


    useEffect(() => {
        fetchUsersCompany();
    }, []);

    const handleImportModalClose = () => {
        setShowImportModal(false);
        setImportType(null);
    };


    const fetchUsersCompany = async (page = 1) => {
        try {
            setLoadingSearch(true);
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}users-officer/officer-list`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    user_id: filters?.user_id,
                    situation: filters?.status?.value
                },
                true
            );

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setUsersOfficer(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 5, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };

    const handleImportButtonClick = () => {
        setImportType(4);
        setShowImportModal(true);
    };

    const handleChange = (selectedOption) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: selectedOption,
        }));
    };


    const handleClearFilters = () => {
        setFilters({
            status: null,
            hospital: null,
        });

        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }

    };


    const handlePageChange = (page) => {
        fetchUsersCompany(page);
    };

    const handleModalClick = () => {
        setShowOfficerModal(true);
    };

    const handleModalClose = (save = false) => {
        setShowOfficerModal(false);

        if(save) {
            fetchUsersCompany(pagination.current);
        }
    };


    const handleStatus = async (id, statusAlterar) => {
        // Verificando se o hospital está correto
        try {
            // Enviar requisição para registrar o hospital para o usuário
            setLoadingPage(true);
            const response = await ApiService.send(
                "post", // Alterei para "post" caso esteja criando o registro
                `${process.env.REACT_APP_URL_API}users-officer/users-status`,
                {
                    user_id: id,
                    situation: statusAlterar
                },
                true
            );
            setLoadingPage(false);
            if (response.code === 200) {
                Swal.fire('Sucesso', 'Funcionário Alterado com sucesso!', 'success');
                const updatedUsersHospital = usersOfficer.map(user => {
                    if (user.id === id) {
                        return {
                            ...user,
                            situation: statusAlterar
                        };
                    }
                    return user; // Retorne o usuário inalterado
                });

                setUsersOfficer(updatedUsersHospital);
            } else {
                Swal.fire('Erro', 'Erro ao registrar hospital', 'error');
            }
        } catch (error) {
            setLoadingPage(false);
            ApiService.handleApiError(error);
        }

    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Funcionário" pageTitle="Configuração"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}


                                    <div className="button-group mb-3">
                                        <button type="button" className="btn btn-outline-dark mr-1  me-2"
                                                onClick={() =>handleImportButtonClick()}>
                                            <i className="fa fa-upload"></i> Importar
                                        </button>
                                    </div>
                                    <div className="row mt-12 mb-12">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Situação</label>
                                                <Select
                                                    key={filters.status ? "has-value" : "no-value"} // Altera a key ao limpar
                                                    options={options}
                                                    value={filters.status} // Garante que o valor seja atualizado corretamente
                                                    onChange={handleChange}
                                                    placeholder="Selecione"
                                                    isClearable
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            width: '100%',
                                                        }),
                                                    }}
                                                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                    styles={{
                                                        menuPortal: base => ({
                                                            ...base,
                                                            zIndex: 9999
                                                        }), // Definindo z-index alto
                                                        menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                    }}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <UsersSearch
                                                title="Funcionário"
                                                ref={refUserSearch}
                                                allTypes={[3]}
                                                onUserSelect={(user) =>
                                                    setFilters((prevFilters) => ({
                                                        ...prevFilters,
                                                        user_id: user?.value || "",
                                                    }))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-12 d-flex justify-content-end">

                                            <button type="button" className="btn  mr-1  me-2"
                                                    onClick={() =>handleClearFilters()}>
                                                <i className="fa fa-eraser"></i> Limpar Filtros
                                            </button>

                                            <button type="button" className="btn btn-info mr-1  me-2"
                                                    onClick={() =>handleModalClick()}>
                                                <i className="fa fa-plus"></i> Cadastrar
                                            </button>

                                            <button type="button" className="btn btn-success"
                                                    onClick={() =>fetchUsersCompany()}
                                                    disabled={loadingSearch}
                                            >
                                                <i className={`fa ${loadingSearch ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i>{" "}
                                                {loadingSearch ? "Buscando..." : "Buscar"}
                                            </button>
                                        </div>
                                    </div>


                        <div className="list-container mt-4">
                            {loadingSearch ? (
                                <Skeleton count={5} height={120}/>
                            ) : usersOfficer.length > 0 ? (
                                usersOfficer.map((user) => (
                                    <Col lg={12} key={user.id}>
                                        <Card className="mb-1 p-2 shadow-sm card-hover">
                                            <CardBody
                                                className="card-body d-flex justify-content-between align-items-center p-2">
                                                <div className="col-2">
                                                    <Avatar
                                                        src={user?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                        size={60}
                                                        className="me-2"
                                                        alt={user?.name || "Usuário sem nome"}
                                                    />
                                                </div>
                                                <div className="col-8">
                                                    <h6 className="doc-name">{user?.name || "Usuário não identificado"}</h6>
                                                    <p className="text-muted mb-1">
                                                        {user.situation === 'accepted' ? (
                                                            <span
                                                                className="badge bg-success d-inline-flex align-items-center">
                                                                                  <i className="fa fa-check me-2"></i> Status Ativo
                                                                                </span>
                                                        ) : (
                                                            <span
                                                                className="badge bg-danger d-inline-flex align-items-center">
                                                                                      <i className="fa fa-times me-2"></i> Status Inativo
                                                                                    </span>

                                                        )}
                                                    </p>

                                                    <p className="text-muted mb-1">
                                                        <i className="fa fa-map-marker text-info me-2"></i>
                                                        {user?.city ? `${user.city}, ${user.state || ""}` : "Local não informado"}
                                                    </p>
                                                    <p className="text-muted mb-1">
                                                        <i className="fa fa-phone text-info me-2"></i>
                                                        Telefone: {user?.ddd && user?.phone ? `(${user.ddd}) ${user.phone}` : "Não informado"}
                                                    </p>
                                                </div>

                                                <div className="row col-2 d-flex align-items-center">
                                                    {user.situation === 'accepted' ? (
                                                        <button type="button"
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => handleStatus(user.id, 'cancel')}>
                                                            <i className="fa fa-close"></i> Inativar
                                                        </button>
                                                    ) : (
                                                        <button type="button"
                                                            className="btn btn-outline-primary  btn-sm"
                                                            onClick={() => handleStatus(user.id, 'accepted')}>
                                                            <i className="fa fa-check"></i> Ativar
                                                        </button>
                                                    )}
                                                </div>


                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <div className="alert alert-primary" role="alert">Nenhum funcionário encontrado.
                                </div>
                            )}
                        </div>

                            {/* Paginação */}
                            <CustomPagination
                                onChange={handlePageChange}
                                pagination={pagination}
                            />

                            {/* Modal de Importação */}
                            {showOfficerModal && (
                                <OfficerModal
                                    show={showOfficerModal}
                                    onHide={handleModalClose}
                                />
                            )}
                            {showImportModal && (
                                <ImportModal
                                    show={showImportModal}
                                    onHide={handleImportModalClose}
                                    importType={importType}
                                />
                            )}

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default OfficerPage;
